<template>
  <path
    d="M12 2.00018C6.47 2.00018 2 6.47018 2 12.0002C2 17.5302 6.47 22.0002 12 22.0002C17.53 22.0002 22 17.5302 22 12.0002C22 6.47018 17.53 2.00018 12 2.00018ZM12 20.0002C7.59 20.0002 4 16.4102 4 12.0002C4 7.59018 7.59 4.00018 12 4.00018C16.41 4.00018 20 7.59018 20 12.0002C20 16.4102 16.41 20.0002 12 20.0002Z"
  />
</template>
